import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { TableComponent } from "src/app/shared/components/ui/table/table.component";
import { ChatMsg } from "src/app/shared/models/chat.model";

@Component({
  selector: "msg-read-status",
  templateUrl: "./msg-read-status.component.html",
  styleUrls: ["./msg-read-status.component.scss"],
  imports: [TranslateModule, CommonModule, TableComponent],
  standalone: true,
})
export class MsgReadStatusComponent implements OnInit {
  @Input() msg: ChatMsg;
  @Output() onClose = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  public closePanel() {
    this.onClose.emit();
  }
}
